export const FARE_ID = {}

export const IS_PRIVATE_FINANCING_ENABLED = false

export const FINANCING_PARTNERS = {}

export const LENDERS_DICTIONARIES = {}

export const INSURANCE_IDS = {}

export const HAS_FINANCING_PRI_ENABLED = false

export const RESERVATION_STATUSES = {
  NON_RESERVABLE: 'non_reservable',
  OTHER_RESERVATION: 'other_reservation',
  OWN_PRE_RESERVATION: 'own_pre_reservation',
  OWN_RESERVATION: 'own_reservation',
  OWN_RESERVATION_PENDING_PHONE: 'own_reservation_pending_phone',
  RESERVABLE: 'reservable'
}
